import React, { useState, useEffect } from 'react'

import LoginButton from './LogInButton'
import LogoutButton from './LogOutButton'
import Popup from './Popup'

const LogInOutButton = ({
  explorer,
  popup = new Popup(),
  microcopy
}) => {
  popup.init({ useState, explorer })
  
  useEffect(() => {
    popup.updateSourcePath()
  }, [])

  return (
    <span>
      { explorer.accessToken.loggedIn() ? 
        <LogoutButton 
          microcopy={microcopy}
          handleLogout={() => explorer.accessToken.logout()} /> :
        <LoginButton 
          microcopy={microcopy}
          waiting={popup.waiting} 
          handleLogin={() => popup.open()} /> }
    </span>
  )
}

export default LogInOutButton

